import DateTimePicker from 'react-widgets/lib/DateTimePicker';
import React, { Component } from 'react';
import 'react-select/dist/react-select.css';
import classNames from 'classnames';
import moment from 'moment';

import ContentWrapper from '../Layout/ContentWrapper';

export class DatePicker extends Component {
  constructor() {
    super();
    this.state = {
      input: '',
      selected: '',
      placeholder: '',
      start: '',
      end: '',
      minDate: '',
      maxDate: '',
      oldIn: '',
      inDate: '',
      dropUp: false,
      errorState: {
        message: '',
        status: '',
      },
    }
  }

  componentWillMount() {
    const { input, selected, placeholder, start, end, minDate, maxDate, dropUp } = this.props;
    const inDate = new Date(this.props.input.value);
    if (start && inDate > maxDate) {
      this.setState({
        input,
        selected,
        placeholder,
        start,
        end,
        dropUp,
        minDate: minDate || new Date(1900, 0, 1),
        maxDate: maxDate || new Date(2099, 11, 31),
        oldIn: '',
        inDate: '',
        errorState: {
          message: 'Error in Start Date',
          status: 'failure',
        }
      });
    } else {
      this.setState({ input, selected, placeholder, start, end, dropUp, minDate: minDate || new Date(1900, 0, 1), maxDate: maxDate || new Date(2099, 11, 31), oldIn: this.props.input.value, inDate: new Date(this.props.input.value), errorState: {
          message: 'Incomplete',
          status: 'incomplete',
        }
      });
    }

    if (end && inDate < minDate) {
      this.setState({ input, selected, placeholder, start, end, dropUp, minDate: minDate || new Date(1900, 0, 1), maxDate: maxDate || new Date(2099, 11, 31), oldIn: '', inDate: '', errorState: {
          message: 'Error in End Date',
          status: 'failure',
        }
      });
    } else {
      this.setState({ input, selected, placeholder, start, end, dropUp, minDate: minDate || new Date(1900, 0, 1), maxDate: maxDate || new Date(2099, 11, 31), oldIn: this.props.input.value, inDate: new Date(this.props.input.value), errorState: {
          message: 'Incomplete',
          status: 'incomplete',
        }
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { input, selected, placeholder, start, end, minDate, maxDate, dropUp } = nextProps;
    const inDate = new Date(nextProps.input.value);
    if (start && inDate > maxDate) {
      this.setState({ input, selected, placeholder, start, end, dropUp, minDate: new Date(1900, 0, 1), maxDate: maxDate || new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: null, errorState: {
          message: 'Error in Start Date',
          status: 'failure',
        }
      });
    } else {
      this.setState({ input, selected, placeholder, start, end, dropUp, minDate: new Date(1900, 0, 1), maxDate: maxDate || new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: new Date(nextProps.input.value), errorState: {
          message: 'Incomplete',
          status: 'incomplete',
        }
      });
    }
    if (end && inDate < minDate) {
      this.setState({ input, selected, placeholder, start, end, dropUp, minDate: minDate || new Date(1900, 0, 1), maxDate: new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: null, errorState: {
          message: 'Error in End Date',
          status: 'failure',
        }
      });
    } else {
      this.setState({ input, selected, placeholder, start, end, dropUp, minDate: minDate || new Date(1900, 0, 1), maxDate: new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: new Date(nextProps.input.value), errorState: {
          message: 'Incomplete',
          status: 'incomplete',
        }
      });
    }
    if ((start && inDate <= maxDate) || (end && inDate >= minDate))
      this.setState({ input, selected, placeholder, start, end, dropUp, minDate: minDate || new Date(1900, 0, 1), maxDate: maxDate || new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: new Date(nextProps.input.value), errorState: {
          message: 'Success',
          status: 'success',
        }
      });
    if (maxDate === null && minDate === null){
      this.setState({ maxDate: new Date(2099, 11, 31), minDate: new Date(1900, 0, 1), inDate: null });
    }
  }

  render() {
    const { input, selected, placeholder, minDate, maxDate, start, end, oldIn, inDate, dropUp } = this.state;
    const { meta: { touched, error } } = this.props;
    const inputClass = classNames({ 'parsley-error-div': touched && error }, this.props.className, 'datePicker', "test-rw-input");
    let date;
    if (selected) {
      date = new Date(selected);
    }
    let isDisabled = false;
    if (this.props.disabled) {
      isDisabled = true;
    }

    if (oldIn.length === 0) {
      return (
        <ContentWrapper>
          {touched && error && <span className="parsley-error-message">{error}</span>}
          <DateTimePicker
            dropUp={dropUp}
            className={inputClass}
            placeholder={placeholder}
            format="MM-DD-YY"
            time={false}
            onChange={(name) => input.onChange(name)}
            min={minDate}
            max={maxDate}
            defaultValue={date}
            disabled={isDisabled}
            style={{ readonly: 'true' }}
          />
        </ContentWrapper>
      )
    }
    return (
      <ContentWrapper>
        {touched && error && <span className="parsley-error-message">{error}</span>}
        <DateTimePicker
          dropUp={dropUp}
          placeholder={placeholder}
          className={inputClass}
          format="MM-DD-YY"
          time={false}
          onChange={(name) => input.onChange(name) }
          min={minDate}
          max={maxDate}
          value={inDate}
          disabled={isDisabled}
        />
      </ContentWrapper>
    )
  }
}

export class DisabledDatePicker extends Component {
  render() {
    const { input, selected, placeholder } = this.props;
    let date;
    if (selected !== null) {
      date = new Date(selected);
    }
    if (input.value.length !== 0) {
      date = new Date(input.value);
    }
    return (
      <DateTimePicker
        placeholder={placeholder}
        className="test-rw-input"
        format="MM-DD-YY"
        defaultValue={selected}
        time={false}
        onChange={(name) => input.onChange(name)}
        value={date || null}
        disabled
      />
    )
  }
}


export class StartOfThisMonthDatePicker extends Component {
  constructor() {
    super();
    this.state = {
      input: '',
      selected: '',
      placeholder: '',
      start: '',
      end: '',
      minDate: '',
      maxDate: '',
      oldIn: '',
      inDate: '',
      dropUp: false,
      errorState: {
        message: '',
        status: '',
      },
    }
  }

  componentWillMount() {
    const { input, selected, placeholder, start, end, minDate, maxDate, dropUp } = this.props;
    const inDate = new Date(this.props.input.value);
    if (start && inDate > maxDate) {
      this.setState({
        input,
        selected,
        placeholder,
        start,
        end,
        dropUp,
        minDate: moment(minDate).startOf('month')._d || moment().startOf('month')._d,
        maxDate: maxDate || new Date(2099, 11, 31),
        oldIn: '',
        inDate: '',
        errorState: {
          message: 'Error in Start Date',
          status: 'failure',
        }
       });
    } else {
      this.setState({ input, selected, placeholder, start, end, dropUp, minDate: moment(minDate).startOf('month')._d || moment().startOf('month')._d, maxDate: maxDate || new Date(2099, 11, 31), oldIn: this.props.input.value, inDate: new Date(this.props.input.value), errorState: {
          message: 'Incomplete',
          status: 'incomplete',
        }
      });
    }

    if (end && inDate < minDate) {
      this.setState({ input, selected, placeholder, start, end, dropUp, minDate: moment(minDate).startOf('month')._d || moment().startOf('month')._d, maxDate: maxDate || new Date(2099, 11, 31), oldIn: '', inDate: '', errorState: {
          message: 'Error in End Date',
          status: 'failure',
        }
      });
    } else {
      this.setState({ input, selected, placeholder, start, end, dropUp, minDate: moment(minDate).startOf('month')._d || moment().startOf('month')._d, maxDate: maxDate || new Date(2099, 11, 31), oldIn: this.props.input.value, inDate: new Date(this.props.input.value), errorState: {
          message: 'Incomplete',
          status: 'incomplete',
        }
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { input, selected, placeholder, start, end, minDate, maxDate, dropUp } = nextProps;
    const inDate = new Date(nextProps.input.value);
    if (start && inDate > maxDate) {
      this.setState({ input, selected, placeholder, start, end, dropUp, minDate: moment(minDate).startOf('month')._d || moment().startOf('month')._d, maxDate: maxDate || new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: null, errorState: {
          message: 'Error in Start Date',
          status: 'failure',
        }
      });
    } else {
      this.setState({ input, selected, placeholder, start, end, dropUp, minDate: moment(minDate).startOf('month')._d || moment().startOf('month')._d, maxDate: maxDate || new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: new Date(nextProps.input.value), errorState: {
          message: 'Incomplete',
          status: 'incomplete',
        }
      });
    }
    if (end && inDate < minDate) {
      this.setState({ input, selected, placeholder, start, end, dropUp, minDate: moment(minDate).startOf('month')._d || moment().startOf('month')._d, maxDate: new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: null, errorState: {
          message: 'Error in End Date',
          status: 'failure',
        }
      });
    } else {
      this.setState({ input, selected, placeholder, start, end, dropUp, minDate: moment(minDate).startOf('month')._d || moment().startOf('month')._d, maxDate: new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: new Date(nextProps.input.value), errorState: {
          message: 'Incomplete',
          status: 'incomplete',
        }
      });
    }
    if ((start && inDate <= maxDate) || (end && inDate >= minDate)) {
      this.setState({ input, selected, placeholder, start, end, dropUp, minDate: moment(minDate).startOf('month')._d || moment().startOf('month')._d, maxDate: maxDate || new Date(2099, 11, 31), oldIn: nextProps.input.value, inDate: new Date(nextProps.input.value), errorState: {
          message: 'Success',
          status: 'success',
        }
      });
    }
    if (maxDate === null && minDate === null){
      this.setState({ maxDate: new Date(2099, 11, 31), minDate: moment(minDate).startOf('month')._d || moment().startOf('month')._d, inDate: null });
    }
  }

  render() {
    const { input, selected, placeholder, minDate, maxDate, start, end, oldIn, dropUp } = this.state;
    const { meta: { touched, error } } = this.props;
    const inputClass = classNames({'parsley-error-div': touched && error }, this.props.className, 'datePicker', "test-rw-input");
    let date;
    if (this.state.inDate === undefined || this.state.inDate === null) {
      let today = moment()._d;
      this.setState({
        inDate: today,
      });
    }
    if (selected) {
      date = new Date(selected);
    }
    let isDisabled = false;
    if (this.props.disabled) {
      isDisabled = true;
    }

    if (oldIn.length === 0) {
      return (
        <ContentWrapper>
          {touched && error && <span className="parsley-error-message">{error}</span>}
          <DateTimePicker
            dropUp={dropUp}
            placeholder={placeholder}
            className={inputClass}
            format="MM-DD-YY"
            time={false}
            onChange={(name) => input.onChange(name)}
            min={ moment(date).startOf('month')._d || moment().startOf('month')._d}
            max={maxDate}
            defaultValue={date} 
            disabled={isDisabled}
            style={{ readonly: 'true' }}
          />
        </ContentWrapper>
      )
    }
    return (
      <ContentWrapper>
        {touched && error && <span className="parsley-error-message">{error}</span>}
        <DateTimePicker
          className={inputClass}
          dropUp={dropUp}
          placeholder={placeholder}
          format="MM-DD-YY"
          time={false}
          onChange={(name) => input.onChange(name)}
          min={moment(this.state.inDate).startOf('month')._d || moment().startOf('month')._d}
          max={maxDate}
          value={this.state.inDate}
          disabled={isDisabled}
        />
      </ContentWrapper>
    )
  }
}

export default DatePicker;



// WEBPACK FOOTER //
// ./master/jsx/components/Common/datePicker.jsx